import fetch from '../plugin/axios/fetch'
import CryptoJS from 'crypto-js/crypto-js'
import { Indicator } from 'mint-ui'
import { RESOURCES_URL } from '@/config/index'
import store from '@/store'
import Axios from 'axios'

/**
 * 通过经纬度获取详细地址
 * @param {*} [{
 *   lat = '39.92',
 *   lng = '116.37'
 * }={}]
 * @returns Promise
 */
export function getAddressByLongitudeAndLatitude ({
  lat = '39.92',
  lng = '116.37'
} = {}) {
  return fetch.post(
    'getAddressByLocation',
    { lat, lng },
    'application/x-www-form-urlencoded;charset=UTF-8'
  )
}

/**
 *
 * 预测邮件投递时间
 * @export
 * @param {*} {
 *  clctDistrictCode	String 寄件人行政区划代码
 *  clctProvName	String	寄件人省份名称
 *  clctCityName	String	寄件人地市名称
 *  clctCntyName	String	寄件人区县名称
 *  clctAddr	String	寄件人详细地址
 *  dlvDistrictCode	String	收件人行政区划代码
 *  dlvProvName	String	收件人省份名称
 *  dlvCityName	String	收件人地市名称
 *  dlvCntyName	String	收件人区县名称
 *  dlvAddr	String	收件人详细地址
 *  clctDatetime	String	预计收寄时间时间格式为：yyyyMMddHHmmss
 * }
 * @returns
 */
export function getPredictionTimeByAddress ({
  clctDistrictCode = '',
  clctProvName = '',
  clctCityName = '',
  clctCntyName = '',
  clctAddr = '',
  dlvDistrictCode = '',
  dlvProvName = '',
  dlvCityName = '',
  dlvCntyName = '',
  dlvAddr = '',
  clctDatetime = ''
} = {}) {
  return fetch.post('external/prediction', {
    clctDistrictCode,
    clctProvName,
    clctCityName,
    clctCntyName,
    clctAddr,
    dlvDistrictCode,
    dlvProvName,
    dlvCityName,
    dlvCntyName,
    dlvAddr,
    clctDatetime
  })
}

/**
 * 获取预估运费
 *
 * @param {*} {
 *   originAmcDistrict, 寄件地址区县行政区划
 *   endAmcDistrict,	收件地址区县行政区划
 *   weight,	重量单位：克
 *   productCode
 * productCode可售卖产品代码，固定值：
 * 到付: 112104302300992,
 * 寄付: 112104302300991
 * 快递包裹：113124300000691
 * }
 * @returns
 */
export function getPredictedFreight ({
  originAmcDistrict = '110102',
  endAmcDistrict = '110102',
  weight = '1000',
  productCode
} = {}) {
  const salt =
    '5DA3C21FFB78E0E934EEA19F7D55774003EBF9F4803DBDB6557C474D83833EA14C2CF6C9BA70AC0967DCE22011D2E979A546959DF452A15CE56BEF7C'
  // 获取预估运费
  const hash = CryptoJS.HmacSHA256(
    JSON.stringify({
      originAmcDistrict,
      endAmcDistrict,
      weight,
      productCode
    }),
    salt
  )
  const hashInBase64 = CryptoJS.enc.Base64.stringify(hash)
  return fetch.post({
    url: 'https://ydmh.ems.com.cn/maportal-web/newmail/api/getEstimate',
    // url: 'https://mock.yonyoucloud.com/mock/15609/getEstimate',
    data: {
      originAmcDistrict,
      endAmcDistrict,
      weight,
      productCode
    },
    headers: {
      'AUTH-SIGN': hashInBase64
      // 'AUTH-TOKEN': 'eyJhbGciOiJIUzI1NiJ9.eyJTU1NfVVJMIjoiIiwiUEhPTkUiOiIxODUyOTM0NzA1NiIsIlVTRVJfSUQiOiJjNDI2MzgyNWRhM2I0ZmFiYWY4ZjIxMjBlNjk1ZmNiZCIsIlVTRVJfQ0hBTk5FTCI6IkFMSVBBWSIsIklTU1VFUl9BVCI6MTU2ODY4NTQ0NTkyMiwiT1BFTl9JRCI6IjE4NTI5MzQ3MDU2IiwiSVNTVUVSIjoibmV3LWdlbmVyYXRpb24tYXBpIiwiUEhPTkVfSUQiOiIiLCJleHAiOjE1NzM4Njk0NDV9.NpIXGj4ed7TKDeXspdWjwDh4tkCZz0-sh4Rt6FY49k4'
    }
  })
}
/**
 * 计算邮件资费接口
 * @param {*} {
 *  productCode，可售卖产品Code
 *  weight，称重重量（克）
 *  aACode
 *  distCode
 *  senderCityNo
 *  isWordOperation，是否返回话术提示
 *  wordOperationType，话术类型：2 在线下单
 *  isCollectionJudge, 疫情管控：1
 * }
 */
export function getMailPostage ({
  productCode = '',
  weight = '',
  length = '',
  width = '',
  height = '',
  aACode = '',
  distCode = '',
  postCode = '',
  senderCityNo = '',
  isWordOperation = '1',
  wordOperationType = '1',
  isCollectionJudge = '1',
  isDiscountProduct = '',
  insuranceMoney = ''
} = {}) {
  return fetch.post('/postage/getMailPostage', {
    productCode,
    weight,
    length,
    width,
    height,
    aACode,
    distCode,
    postCode: postCode.replace(/\s/g, ''),
    senderCityNo,
    isWordOperation,
    wordOperationType,
    isCollectionJudge,
    isDiscountProduct,
    insuranceMoney,
    duty: +insuranceMoney ? '2' : ''
  })
}
/**
 * 获取预约时间
 * @param {*} {
 *   collectProvUnit, 寄件人省级代码
 *   collectCityUnit, 寄件人市级代码
 *   collectCountyUnit, 寄件人县级代码
 *   collectAddrName 详细地址
 * }
 * @returns
 */
export async function getAppointTimeBySender ({
  provName,
  cityName,
  contyName,
  address
} = {}) {
  let reg = /-/g
  let { data = {} } = await fetch.post('/order/v4/appoint-time', {
    provName: provName,
    cityName: cityName,
    contyName: contyName,
    address: address,
    biz_product_no: '1'
  })
  if (data && data.code === '000000') {
    let {
      workStartTime,
      workEndTime,
      workAppointBegin,
      workAppointEnd,
      UnitService
    } = data.info
    return {
      workStartTime: workStartTime.replace(reg, '/'),
      workEndTime: workEndTime.replace(reg, '/'),
      workAppointBegin: workAppointBegin.replace(reg, '/'),
      workAppointEnd: workAppointEnd.replace(reg, '/'),
      UnitService: UnitService !== '3',
      UnitServiceCode: UnitService
    }
  } else {
    return {
      workStartTime: '',
      workEndTime: '',
      workAppointBegin: '',
      workAppointEnd: '',
      UnitService: true,
      UnitServiceCode: '0'
    }
  }
}

/**
 *
 * 分享之前保存数据，分享成功之后取数据
 * @param {*} {
 *   data = {}, 需要保存/取出的数据
 *   flag: 1, 保存(1)/取出(2)标志
 *   code: '' flag为2时为必传
 * }
 */
export function saveOrGetShareData ({ data = {}, flag = 1, code = '' }) {
  return fetch.post('mailOrder/getShareInfo', {
    data,
    flag,
    code
  })
}

/**
 * 62城时效承诺查询接口
 * 接口参数全部为必传
 * @param {*} [{
 *   appointTime, 拟收寄时间（格式yyyy-mm-dd HI:MM:SS）
 *   sendProvince, 寄件省份
 *   sendCity, 寄件城市
 *   sendArea, 寄件地区
 *   sendAddress, 寄件详细地址
 *   receiveProvince, 收件省份
 *   receiveCity, 收件城市
 *   receiveArea, 收件地区
 *   receiveAddress 收件详细地址
 *   productType 产品类型 7：标快 8：快包
 * }={}]
 * @returns Promise
 */
export function getPromiseData ({
  appointTime,
  sendInfo,
  receInfo,
  startDetail: sendAddress,
  endDetail: receiveAddress,
  productType
} = {}) {
  appointTime = (appointTime || '').replace(
    /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
    '$1-$2-$3 $4:$5:$6'
  )
  return fetch.post({
    // url: 'http://10.1.149.150:6001/bank-claim/lte/queryPromise',
    url: `/lte/queryPromise`,
    // url: `https://mock.yonyoucloud.com/mock/15609/lte/queryPromise`,
    data: {
      appointTime,
      sendProvince: sendInfo.userProvince,
      sendCity: sendInfo.userCity,
      sendArea: sendInfo.userArea,
      sendAddress,
      receiveProvince: receInfo.userProvince,
      receiveCity: receInfo.userCity,
      receiveArea: receInfo.userArea,
      receiveAddress,
      productType
    }
  })
}

/**
 * 获取省市文件
 */
export async function getCitiesJson () {
  Indicator.open()
  const { data } = await Axios(
    `${RESOURCES_URL}/json/addressTree.json?t=${Date.now()}`
  )
  store.dispatch('addressInfo/setAddressTree', data)
  Indicator.close()
  return data
}

/**
 * 获取国际 热门国家
 */
// const intURL = process.env.VUE_APP_NODE_ENV === 'production' ? '/new-generation-int' : '/new-generation-int-dev'
export async function getHotCountries () {
  const { data = {} } = await fetch.post({
    // baseURL: '/new-generation-int',
    url: '/address/queryPopularCountries'
  })
  return data
}
/**
 * 获取国际国家数据
 */
export async function getCountryInformation (params) {
  let { data = '' } = await fetch.post({
    // baseURL: intURL,
    url: '/order/queryCountryInformation',
    data: params
  })
  return data
  // if (data && data.code === '000000') {
  //   return data.info
  // } else {
  //   return []
  // }
}

/**
 * 获取国家产品数据
 */
export async function getIntProductListApi (params) {
  let { data = '' } = await fetch.post({
    // baseURL: intURL,
    url: '/order/queryBillingZoneIntlProduct',
    data: params
  })
  if (data && data.code === '000000') {
    return data.info
  } else {
    return []
  }
}
/**
 * 获取国际预计送达时间
 */
export async function getIntPromiseTime (params) {
  let { data = '' } = await fetch.post({
    // baseURL: intURL,
    url: '/external/getOuterStandardSearch',
    data: params
  })
  if (data && data.code === '000000') {
    return data.info
  } else {
    return ''
  }
}

/**
 * 官网接口
 */
const intWebURL =
  process.env.VUE_APP_NODE_ENV === 'production'
    ? 'https://www.ems.com.cn/ems-web'
    : 'https://www.ems.com.cn/ems-web'
// const intWebURL = process.env.VUE_APP_NODE_ENV === 'production' ? 'https://www.ems.com.cn/ems-web' : 'http://211.156.216.239/ems-web'
// 获取重量 边长限制
export async function getLimitationInfo (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/limitationRegion/queryAreaSize',
    data: params
  })
  return data
}
// 获取预计到达时间（国际时效接口） 主要是特快专递 -- 遗弃
export async function getIntPromiseData (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/khl/getGCXml',
    data: params
  })
  return data
}
// 获取国际省列表
export async function getIntProvList (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/limitationRegion/getProvince',
    data: params
  })
  return data
}
// 获取国际市列表
export async function getIntCityList (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/limitationRegion/getCity',
    data: params
  })
  return data
}
// 内地寄件邮编获取
export async function getLandPostCode (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/limitationRegion/querySendPostCode',
    data: params
  })
  return data
}
// 国际邮编获取
export async function getIntPostCode (params) {
  const { data = {} } = await fetch.post({
    baseURL: intWebURL,
    url: '/limitationRegion/getPostCode',
    data: params
  })
  return data
}
// --- 官网接口 END --

/**
 * 提交时效满意度评价
 * @param {*} {
 *   sendPro, 寄件省份
 *   sendCity, 寄件城市
 *   sendArea, 寄件地区
 *   sendProCode 寄件省份Code
 *   sendCityCode, 寄件城市Code
 *   sendAreaCode, 寄件地区Code
 *   sendAddress, 寄件详细地址
 *   receivePro 收件省份
 *   receiveCity, 收件城市
 *   receiveArea, 收件地区
 *   receiveProCode, 收件省份Code
 *   receiveCityCode 收件城市Code
 *   receiveAreaCode, 收件地区Code
 *   receiveAddress, 收件详细地址
 *   isSatisfied 0不满意 1满意
 *   noSatisfiedLab 不满意标签
 *   noSatisfiedMsg 不满意说明
 *   countyModel 1: 寄国内 2: 寄港澳台 3:寄国际
 * }
 * @returns
 */
export function putLimitEvaluation ({
  sendPro,
  sendCity,
  sendArea,
  sendProCode,
  sendCityCode,
  sendAreaCode,
  sendAddress,
  receivePro,
  receiveCity,
  receiveArea,
  receiveProCode,
  receiveCityCode,
  receiveAreaCode,
  receiveAddress,
  isSatisfied,
  noSatisfiedLab,
  noSatisfiedMsg,
  countyModel
} = {}) {
  return fetch.post('/lte/putLimitEvaluation', {
    sendPro,
    sendCity,
    sendArea,
    sendProCode,
    sendCityCode,
    sendAreaCode,
    sendAddress,
    receivePro,
    receiveCity,
    receiveArea,
    receiveProCode,
    receiveCityCode,
    receiveAreaCode,
    receiveAddress,
    isSatisfied,
    noSatisfiedLab,
    noSatisfiedMsg,
    countyModel
  })
}
/**
 * 获取满意度评价资格
 */
export async function putEvaluationQft (queryParams) {
  return fetch.post({ url: '/lte/putEvaluationQft', data: queryParams })
}

/**
 * 业务说明/温馨提醒
 * @returns Promise
 */
export async function getConsoleTipsInfo (queryParams) {
  return fetch.post({ url: '/lte/getConsoleTipsInfo', data: queryParams })
}

/**
 * 可售卖产品接口
 * @returns Promise
 */
export async function getDayProductService ({
  weight,
  provName,
  cityName,
  contyName,
  address,
  receProvName,
  receCityName,
  receContyName,
  receAddress,
  type = '1',
  // eslint-disable-next-line
  biz_product_no = '',
  // eslint-disable-next-line
  payment_mode = 1,
  // eslint-disable-next-line
  contents_attribute = 3
} = {}) {
  return fetch.post({
    // baseURL: 'http://192.191.168.115:7072/newmail/api',
    url: '/order/queryProductService',
    data: {
      weight,
      provName,
      cityName,
      contyName,
      address,
      receProvName,
      receCityName,
      receContyName,
      receAddress,
      type,
      biz_product_no,
      payment_mode,
      contents_attribute
    }
  })
}

/**
 *  根据userId,addressId查询地址信息
 * @returns Promise
 */
export async function getAddressInfo ({ userId, addressId }) {
  const apiURL =
    process.env.VUE_APP_NODE_ENV === 'production'
      ? '/new-generation-api'
      : '/new-generation-api-dev'
  const result = await fetch.post({
    baseURL: apiURL, // 可能需要测试包调生产接口，但这里地址簿就不一样
    url: 'userAddress/getAddrById',
    data: {
      userId,
      addrId: addressId
    }
  })
  return result.data
}

/**
 * 查询保价类型和保额上限
 */
export async function getInsuredTypeAndLimit (params) {
  let { data = '' } = await fetch.post({
    url: '/postage/queryInsuredTypeAndLimit',
    data: params
  })
  if (data && data.code === '000000') {
    return data.info
  } else {
    return []
  }
}

/**
 * 查询用户基本信息
 */
export async function getUserInfo () {
  let { data = '' } = await fetch.post(
    'getLoginUserInfo',
    {},
    'application/x-www-form-urlencoded;charset=UTF-8'
  )
  if (data && data.code === '000000') {
    return data.info
  } else {
    return {}
  }
}

/**
 * 查询汇率
 */
export async function findCurrencyRateInfoNewApi (data) {
  const apiURL = process.env.VUE_APP_CLOUD_BASE_URL
  let res = await fetch.post({
    baseURL: apiURL + '/ecr-int-web',
    url: '/external/findCurrencyRateInfoNew',
    data
  })
  return res.data
}

/**
 * 中铁快运 - 中铁询价接口
 * https://ecuat.ems.com.cn/ecr-mini-web/ztExpress/inquiryPrice
 */
export async function inquiryPrice (data, openId) {
  const apiURL = process.env.VUE_APP_CLOUD_BASE_URL
  let res = await fetch.post({
    baseURL: apiURL + '/ecr-mini-web',
    url: '/ztExpress/inquiryPrice',
    data,
    headers: {
      'Content-Type': 'application/json',
      openId: openId,
      'Mini-Sign': 'BBC885B7E93494700B354032AD9A85A9',
      'Mini-Timestamp': new Date().getTime()
    }
  })
  return res.data
}

/**
 * 中铁快运需求新增 - 地址反查经纬度
 */
export async function getGeoAddress (params) {
  const apiURL = process.env.VUE_APP_CLOUD_BASE_URL
  let res = await fetch.post({
    baseURL: apiURL + '/ecr-exp-web',
    url: '/getGeoAddress',
    params
  })
  return res.data
}
